const ancillariesAbsCollection = require('od-modules/collections/ancillaries_abs.collection').getInstance();
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const Fetcher = require('od-modules/utils/fetcher');
const frontendShell = require('od-modules/frontend-shell');

const insurancesMock = [
    {offerKey: 'ASTONL162'},
];

const GET_INSURANCE_OFFERS_QUERY = `query getInsuranceOffers($bookingId: Long!) {
    getInsuranceOffers(request: { bookingId: $bookingId }) {
        insurances {
            offerKey
        }
    }
}`;

const fetchInsurances = async({bookingData}) => {
    const variables = {bookingId: bookingData.bookingBasicInfo.id};
    return Fetcher.query(GET_INSURANCE_OFFERS_QUERY, variables).then(({data} = {}) => {
        const {getInsuranceOffers = {}} = data || {};
        return getInsuranceOffers.insurances || [];
    }).catch((e) => {
        return Promise.resolve([]);
    });
};

const getInsurances = ({bookingData}) => {
    return websiteConfigCollection.isCheckinAvailableInsurances()
        ? Promise.resolve(insurancesMock)
        : fetchInsurances({bookingData});
};

const getInsurancesByAb = ({bookingData}) =>
    ancillariesAbsCollection.get('cmfInsurances') ? getInsurances({bookingData}) : Promise.resolve([]);

const filterOfferedInsurances = async(insurances) => {
    let offeredInsurancesInCMF = [];

    await frontendShell.execute(({checkinMicrofunnel}) => {
        offeredInsurancesInCMF = checkinMicrofunnel.OFFERED_INSURANCES_IN_CMF;
    });

    return insurances.filter(({offerKey}) => offeredInsurancesInCMF.includes(offerKey));
};

async function hasInsurancesAvailable({bookingData} = {}) {
    const insurances = await getInsurancesByAb({bookingData});
    const filteredInsurances = await filterOfferedInsurances(insurances);

    return filteredInsurances.length > 0;
}

module.exports = {
    hasInsurancesAvailable,
};
